import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fieldProps", "request", "params", "proFieldProps"];
import React from 'react';
import ProFormField from "../Field";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 级联选择框
 *
 * @param
 */
var ProFormTreeSelect = function ProFormTreeSelect(_ref, ref) {
  var fieldProps = _ref.fieldProps,
    request = _ref.request,
    params = _ref.params,
    proFieldProps = _ref.proFieldProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ProFormField, _objectSpread({
    valueType: "treeSelect",
    fieldProps: fieldProps,
    ref: ref,
    request: request,
    params: params,
    filedConfig: {
      customLightMode: true
    },
    proFieldProps: proFieldProps
  }, rest));
};
var WarpProFormTreeSelect = /*#__PURE__*/React.forwardRef(ProFormTreeSelect);
export default WarpProFormTreeSelect;